import { useQuery } from '@tanstack/react-query';
import { trpc, type RouterInputs, type RouterOutputs } from '../../../api/trpc';

export type Report = RouterOutputs['performance']['report'];
export type PeriodReport = Report['current'];
export type ReportInput = RouterInputs['performance']['report'];
export type FilterOptions = RouterOutputs['performance']['filterOptions'];
export type ChannelRow = PeriodReport['channels'][number];
export type CampaignRow = PeriodReport['campaigns'][number];
export type Metric = PeriodReport['kpis']['leads'];

/** The dashboard's numbers for one filter; kept for a while so switching views does not refetch. */
export function useReport(input: ReportInput, enabled: boolean) {
  return useQuery(
    trpc.performance.report.queryOptions(input, { enabled, staleTime: 60_000, placeholderData: (prev) => prev }),
  );
}

export function useFilterOptions() {
  return useQuery(trpc.performance.filterOptions.queryOptions(undefined, { staleTime: 5 * 60_000 }));
}
